import { render } from "./MasterOrganogramaNo.vue?vue&type=template&id=c731d4fc&scoped=true"
import script from "./MasterOrganogramaNo.vue?vue&type=script&lang=js"
export * from "./MasterOrganogramaNo.vue?vue&type=script&lang=js"

import "./MasterOrganogramaNo.vue?vue&type=style&index=0&id=c731d4fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c731d4fc"]])

export default __exports__